const formatNumber = (number) =>
  parseFloat(number).toLocaleString();

export default formatNumber